var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ib-col", [
    _c("p", [
      _vm._v("selected country is "),
      _c("b", [_vm._v(_vm._s(_vm.selectedCountry))]),
    ]),
    _c("p", [
      _vm._v("selected product is "),
      _c("b", [_vm._v(_vm._s(_vm.selectedProduct))]),
    ]),
    _c("p", [
      _vm._v("selected new product checkbox "),
      _c("b", [_vm._v(_vm._s(_vm.newProducts))]),
    ]),
    _c("p", [
      _vm._v("selected exchange type "),
      _c("b", [_vm._v(_vm._s(_vm.selectedExchange))]),
    ]),
    _c("p", [
      _vm._v("selected exchange type "),
      _c("b", [_vm._v(_vm._s(_vm.selectedExch))]),
    ]),
    _c("p", [
      _vm._v("search product type "),
      _c("b", [_vm._v(_vm._s(_vm.searchProductType))]),
    ]),
    _c("p", [
      _vm._v("selected product type "),
      _c("b", [_vm._v(_vm._s(_vm.selectedProductType))]),
    ]),
    _c("p", [
      _vm._v(
        "default region/selected region based on country of residence is "
      ),
      _c("b", [_vm._v(_vm._s(_vm.defaultRegion))]),
    ]),
    _c("p", [
      _vm._v("selected region is "),
      _c("b", [_vm._v(_vm._s(_vm.selectedRegion))]),
    ]),
    _c("p", [
      _vm._v("page number is "),
      _c("b", [_vm._v(_vm._s(_vm.pageNumber))]),
    ]),
    _c("p", [
      _vm._v("totalPages is "),
      _c("b", [_vm._v(_vm._s(_vm.totalPages))]),
    ]),
    _c("p", [
      _vm._v("num show is "),
      _c("b", [_vm._v(" " + _vm._s(_vm.numShow))]),
    ]),
    _c("p", [
      _vm._v("types list is "),
      _c("b", [_vm._v(" " + _vm._s(_vm.typesList))]),
    ]),
    _c("b", [_vm._v(_vm._s(_vm.status))]),
    _c("p", [_vm._v("api status"), _c("b", [_vm._v(_vm._s(_vm.apiStatus))])]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }